/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LookupDefault {
  None = 'None',
  MyUser = 'MyUser',
  MyDefaultTeam = 'MyDefaultTeam',
  MyPerson = 'MyPerson',
  MyOrganisation = 'MyOrganisation'
}
